import AboutMe from "../pages/AboutMe.jsx";
import Contact from "../pages/Contact.jsx"
import HomeSection from "../components/HomeSection.jsx"

export default function Home() {
  return (
  <>
    <HomeSection/>
    <AboutMe />
    <Contact />
  </>
  );
}
